export const ThinkingIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 32 32"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M26.807 9.569A4.68 4.68 0 0 1 30 14.005c0 2.072-1.351 3.813-3.224
                4.436c.04.252.08.513.08.785c0 2.595-2.092 4.698-4.674 4.698c-1.102
                0-2.093-.403-2.893-1.037A3.65 3.65 0 0 1 15.984 25c-1.462
                0-2.713-.865-3.304-2.113a4.58 4.58 0 0 1-2.893 1.037c-2.582
                0-4.675-2.103-4.675-4.698c0-.262.038-.506.076-.758l.004-.027A4.68
                4.68 0 0 1 2 14.005c0-2.072 1.341-3.812 3.203-4.446a5 5 0 0
                1-.08-.785c0-2.595 2.093-4.698 4.675-4.698c1.101 0 2.093.403
                2.893 1.036A3.65 3.65 0 0 1 15.996 3c1.472 0 2.723.865 3.324
                2.123a4.58 4.58 0 0 1 2.893-1.037c2.582 0 4.675 2.103 4.675
                4.698c0 .262-.038.506-.076.758zM7 26.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0"
            />
        </svg>
    );
};
